module.exports = __webpack_public_path__ + "img/translator-EN.4a3e9ba.svg";